import { api } from ".";
import { MaterialContractBase } from "../types/materialContractBase";
import { MaterialUpdate } from "../types/materialUpdate";

export default class MaterialApi {
  static async login(id: number, email: string) {
    const res = await api.post("/materialContract/login", {
      id: id,
      email: email,
    });
    return res.data;
  }

  static async getContract(): Promise<MaterialContractBase> {
    const res = await api.get("/materialContract/getContract");
    return res.data;
  }

  static async getUpdatedMaterial(id: number): Promise<MaterialUpdate> {
    const res = await api.get(`/materialContract/getUpdatedMaterial?id=${id}`);
    return res.data;
  }

  static async updateMaterial(
    origin: string,
    ncm: string,
    price: string,
    icms: string,
    icmsReduction: string,
    IsIcmsSt: boolean,
    icmsSt: string,
    ipi: string,
    leadTimeDays: number,
    netPrice: string,
    materialId: number
  ): Promise<MaterialContractBase> {
    const res = await api.post("/materialContract/updateMaterial", {
      materialUpdate: {
        origin: origin,
        ncm: ncm,
        price: price,
        icms: icms,
        icmsReduction: icmsReduction,
        IsIcmsSt: IsIcmsSt,
        icmsSt: icmsSt,
        ipi: ipi,
        leadTimeDays: leadTimeDays,
        netPrice: netPrice,
      },
      materialId: materialId,
    });
    return res.data;
  }

  static async updateContract(
    taxes: string,
    pis: number,
    confins: number,
    incoterm: string
  ): Promise<MaterialContractBase> {
    const res = await api.post("/materialContract/updateContract", {
      materialContractUpdate: {
        taxes: taxes,
        pis: pis,
        confins: confins,
        incoterm: incoterm,
      },
    });
    return res.data;
  }

  static async partialUpdateContract(
    taxes: string,
    pis: string,
    confins: string,
    incoterm: string
  ): Promise<MaterialContractBase> {
    const res = await api.post("/materialContract/partialUpdateContract", {
      materialContractUpdate: {
        taxes: taxes,
        pis: pis,
        confins: confins,
        incoterm: incoterm,
      },
    });
    return res.data;
  }

  static async setDiscontinued(id: number, discontinued: boolean) {
    await api.post("/materialContract/setDescontinued", {
      materialId: id,
      discontinued: discontinued,
    });
  }

  static async setKeepConditions(keepConditions: boolean) {
    await api.post("/materialContract/setKeepConditions", {
      keepConditions: keepConditions,
    });
  }

  static async setProblem(issueText: string) {
    await api.post("/materialContract/problem", {
      issueText: issueText,
    });
  }
}
